function computeAveragedPosition(tagList) {
  if(tagList === undefined || tagList === null || tagList.length == 0) {
    return {};
  }
  
  const relevantIds = ['711', '712', '713', '714'];

  // Extract coordinates from botCoordinateX and botCoordinateY
  const tagCoords = relevantIds
    .map(id => {
      const tag = tagList[id];
      if (!tag) return null;

      const x = tag.botCoordinateX;
      const y = tag.botCoordinateY;

      if (typeof x === 'number' && typeof y === 'number' && !isNaN(x) && !isNaN(y)) {
        return { id, coord: [x, y] };
      }

      return null;
    })
    .filter(Boolean);


  if (tagCoords.length < 3) {
    
    return tagList;
  }

  // Compute pairwise distances
  const distances = [];
  for (let i = 0; i < tagCoords.length; i++) {
    const [x1, y1] = tagCoords[i].coord;
    for (let j = i + 1; j < tagCoords.length; j++) {
      const [x2, y2] = tagCoords[j].coord;
      const dist = Math.hypot(x1 - x2, y1 - y2);
      distances.push({ dist, tags: [tagCoords[i].id, tagCoords[j].id] });
    }
  }

  // Pick closest 3 tags
  distances.sort((a, b) => a.dist - b.dist);
  const involved = new Set();
  for (const { tags } of distances) {
    involved.add(tags[0]);
    involved.add(tags[1]);
    if (involved.size >= 3) break;
  }

  // Average their coordinates
  const coordsToAverage = Array.from(involved).map(id => {
    const tag = tagList[id];
    return [tag.botCoordinateX, tag.botCoordinateY];
  });

  const total = coordsToAverage.reduce(
    ([sx, sy], [x, y]) => [sx + x, sy + y],
    [0, 0]
  );
  const avgX = total[0] / coordsToAverage.length;
  const avgY = total[1] / coordsToAverage.length;

  // Update tag 711
  if (!tagList['711']) tagList['711'] = { botId: '711' };
  tagList['711'].botCoordinateX = avgX;
  tagList['711'].botCoordinateY = avgY;

  // Remove others
  ['712', '713', '714'].forEach(id => delete tagList[id]);

  return tagList;
}

export default computeAveragedPosition;
